import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, distinctUntilChanged, Observable, of, OperatorFunction, switchMap, tap } from 'rxjs';
import { HammaddeService } from 'src/app/_services/hammadde.service';

@Component({
  selector: 'app-addallergen',
  templateUrl: './addallergen.component.html',
  styleUrls: ['./addallergen.component.css']
})
export class AddallergenComponent implements OnInit {

  constructor(    private toastr: ToastrService,   private activeModal:NgbActiveModal,
    private hammaddeService:HammaddeService,) { }

  ngOnInit() {
  }
  close(){
    this.activeModal.close();
  }


  submitted=false;
  madde:any;
	searching = false;
	searchFailed = false;


  search: OperatorFunction<string, any[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => (this.searching = true)),
			switchMap((term) =>
				this.hammaddeService.search(term,1).pipe(
					tap(() => (this.searchFailed = false)),
					catchError(() => {
						this.searchFailed = true;
						return of([]);
					}),
				),
			),
			tap(() => (this.searching = false)),
		);


    formatter = (x: { inciName: string }) => x.inciName;


    save(){
      if(this.madde)
      this.hammaddeService.addAllergens(this.madde.id).subscribe(res=>{
        this.toastr.success ('Başarılı', 'Allerjen eklendi');
        this.submitted=false;
      });

      else{
        this.toastr.error('', 'Kayıt güncelleme sırasında hata oluştu');
        this.submitted=false;
      }
    }

}
